<template>
  <span data-toggle="popover" :data-placement="placement || 'top'" :data-content="content" class="hover-pointer">
    <slot></slot>
  </span>
</template>

<script lang="ts">
  
  import { Component, Prop, Vue } from 'vue-facing-decorator';
  @Component
  export default class Popover extends Vue {
    @Prop({ type: String }) content!: string;
    @Prop({ type: String }) placement!: string;

    mounted() {
      window.$(this.$el).popover({
        animation: true,
        trigger: 'hover',
        html: true,
      });
    }
  }
</script>
